import { Component, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';
import { GridReadyEvent, ValueGetterParams, RowModelType, SortModelItem, GridApi, ColDef, GridOptions, IDetailCellRendererParams, CellEditingStoppedEvent, CellEditingStartedEvent  } from 'ag-grid-community';
import { HttpClient } from '@angular/common/http';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ViewRateDetailsComponent } from './view-rate-details/view-rate-details.component';


@Component({
  selector: 'app-view-rates',
  templateUrl: './view-rates.component.html',
  styleUrls: ['./view-rates.component.scss']
})
export class ViewRatesComponent implements AfterViewInit {
  defaultGridReady: boolean = false;
  customerGridReady: boolean = false;
  carrierGridReady: boolean = false;
  eventData: CellEditingStoppedEvent | null = null; 
  editModal: boolean = false;

  detailCellRenderer = ViewRateDetailsComponent;
  themeClass: string = 'ag-theme-ulaap';
  defaultGridOptions: GridOptions = {
    overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Loading...</span>',
    overlayNoRowsTemplate: '<span class="ag-overlay-loading-center">nuffing</span>',
    detailCellRendererParams: {
      detailGridId: 'default-rates',
    },
    onCellEditingStarted: this.onCellEditingStarted.bind(this),
    onCellEditingStopped: this.onCellEditingStopped.bind(this)
  };
  customerGridOptions: GridOptions = {
    overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Loading...</span>',
    overlayNoRowsTemplate: '<span class="ag-overlay-loading-center">nuffing</span>',
    detailCellRendererParams: {
      detailGridId: 'customer-rates',
    },
    onCellEditingStarted: this.onCellEditingStarted.bind(this),
    onCellEditingStopped: this.onCellEditingStopped.bind(this)
  };
  carrierGridOptions: GridOptions = {
    overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Loading...</span>',
    overlayNoRowsTemplate: '<span class="ag-overlay-loading-center">nuffing</span>',
    detailCellRendererParams: {
      detailGridId: 'carrier-rates',
    },
    onCellEditingStarted: this.onCellEditingStarted.bind(this),
    onCellEditingStopped: this.onCellEditingStopped.bind(this)
  };
  public defaultColDef: ColDef = { // the default col def, not for the default rates grid specifically
    sortable: true,
    filter: 'agNumberColumnFilter',
    filterParams: {
      caseSensitive: false,
      buttons: ['apply', 'clear', 'reset']
    },
    autoHeight: true,
    resizable: true,
  };

  // Default Rates Grid stuff
  defaultGridApi!: GridApi<any>;
  defaultRowData?: any[];
  defaultLoading: boolean = true;  // flag to control loading state, yeah, it's very dirty
  defaultColumnDefs: ColDef[] = [
    { field: 'cost_or_billable', headerName: 'Cost or Billable?', filter: 'agSetColumnFilter', cellRenderer: 'agGroupCellRenderer' },
    {
      field: 'rate',
      headerName: 'Rate',
      pinned: 'right',
      editable: true,
      valueGetter: (params) => {
          const rate = params.data?.rate;
  
          const numRate = parseFloat(rate) / 100; // rate is in cents, so conversion needed
  
          // ughhhhhhh 
          return isNaN(numRate) ? '0.00' : numRate.toFixed(2); 
      },
      valueSetter: (params) => {
        params.data.rate = params.newValue * 100;
        return true;
      }
  },
    { field: 'origin_zone_description', headerName: 'Origin Zone', filter: 'agTextColumnFilter' },
    { field: 'destination_zone_description', headerName: 'Destination Zone', filter: 'agTextColumnFilter' },
    { field: 'rate_method', headerName: 'Measurement Type', filter: 'agSetColumnFilter', valueGetter: (params) => params.data.rate_method == 2 ? 'LENGTH' : 'WEIGHT' },
    { field: 'rate_unit', headerName: 'Unit', filter: 'agSetColumnFilter',
      valueGetter: p => {
        switch(p.data.rate_unit){
          case 1: return 'LBS';
          case 2: return 'KG';
          case 3: return 'FT';
          case 4: return 'M';
          default: return '';
        }
      }
     },
    { field: 'measurement_start', valueGetter: this.measurementStartGetter },
    { field: 'measurement_end', valueGetter: this.measurementEndGetter },
    { field: 'start_date', filter: 'agDateColumnFilter' },
    { field: 'end_date' , filter: 'agDateColumnFilter'},
    { field: 'length_start', hide: true },
    { field: 'length_end', hide: true },
    { field: 'weight_start', hide: true },
    { field: 'weight_end', hide: true },
  ];

  // Customer Rates Grid Stuff
  customerGridApi!: GridApi<any>;
  customerRowData?: any[];
  customerLoading: boolean = true;
  customerColumnDefs: ColDef[] = [
    //{ field: 'rate', pinned: 'right', headerName: 'Rate (per lb/ft)', valueGetter: p => p.data.rate.toFixed(2)},
    {
      field: 'rate',
      headerName: 'Rate',
      pinned: 'right',
      valueGetter: (params) => {
          const rate = params.data?.rate;
  
          const numRate = parseFloat(rate) / 100; 
  
          // ughhhhhhh 
          return isNaN(numRate) ? '0.00' : numRate.toFixed(2); 
      },
      valueSetter: (params) => {
        params.data.rate = params.newValue * 100;
        return true;
      },
      editable: true,
  },
    { field: 'contact_organization', headerName: 'Customer', filter: 'agTextColumnFilter', cellRenderer: 'agGroupCellRenderer',},
    { field: 'origin_zone_name', headerName: 'Origin Zone', filter: 'agSetColumnFilter'},
    { field: 'destination_zone_name', headerName: 'Destination Zone', filter: 'agSetColumnFilter'},
    { field: 'start_date', headerName: 'Effective Start', filter: 'agDateColumnFilter'},
    { field: 'end_date', headerName: 'Effective End', filter: 'agTextColumnFilter'},
    { field: 'rate_unit', valueGetter: p => p.data.rate_unit === 1 ? 'WEIGHT' : 'LENGTH', headerName: 'Measurement Type', filter: 'agSetColumnFilter' },
    { field: 'measurement_start', headerName: 'Measurement Start', valueGetter: this.measurementStartGetter},
    { field: 'measurement_end', headerName: 'Measurement End',valueGetter: this.measurementEndGetter},
    { field: 'min_rate', headerName: 'Minimum Rate',
      valueGetter: (params) => {
        const rate = params.data?.min_rate;

        const numRate = parseFloat(rate) / 100; 

        // ughhhhhhh 
        return isNaN(numRate) ? '0.00' : numRate.toFixed(2); 
      },
      valueSetter: (params) => {
        params.data.min_rate = params.newValue * 100;
        return true;
      }
    },
    { field: 'transit_days', headerName: 'Transit Days'}
  ];

  // Carrier grid stuff
  carrierGridApi!: GridApi<any>;
  carrierRowData?: any[];
  carrierLoading: boolean = true;
  carrierColDefs: ColDef[] = [
    { field: 'contact_organization', headerName: 'Carrier', filter: 'agTextColumnFilter', cellRenderer: 'agGroupCellRenderer'},
    { field: 'start_date', headerName: 'Start Date', filter: 'agDateColumnFilter'},
    { field: 'end_date', headerName: 'End Date', filter: 'agDateColumnFilter'},
    { field: 'origin_zone_name', headerName: 'Origin Zone', filter: 'agSetColumnFilter'},
    { field: 'destination_zone_name', headerName: 'Destination Zone', filter: 'agSetColumnFilter'},
    { field: 'rate_method', headerName: 'Measurement Type', filter: 'agSetColumnFilter',
      valueGetter: p => p.data.rate_method == 1 ? 'WEIGHT': 'LENGTH'
    },
    { field: 'rate_unit', headerName: 'Unit', filter: 'agSetColumnFilter',
      valueGetter: p => {
        switch(p.data.rate_unit){
          case 1: return 'LBS';
          case 2: return 'KG';
          case 3: return 'FT';
          case 4: return 'M';
          default: return '';
        }
      }
    },
    { field: 'rate', headerName: 'Rate', editable: true, pinned: 'right',
      valueGetter: (params) => {
        const rate = params.data?.rate;
        const numRate = parseFloat(rate) / 100; 
        return isNaN(numRate) ? '0.00' : numRate.toFixed(2); 
      },
      valueSetter: (params) => {
        params.data.rate = params.newValue * 100;
        return true;
      }
    },
    { field: 'min_rate', headerName: 'Minimum Rate', 
      valueGetter: (params) => {
        const rate = params.data?.min_rate;
        const numRate = parseFloat(rate) / 100; 
        return isNaN(numRate) ? '0.00' : numRate.toFixed(2); 
      },
      valueSetter: (params) => {
        params.data.min_rate = params.newValue * 100;
        return true;
      }
    },
    { field: 'measurement_start', headerName: 'Measurement Start', valueGetter: this.measurementStartGetter},
    { field: 'measurement_end', headerName: 'Measurement End',valueGetter: this.measurementEndGetter}
  ];

  constructor(private http: HttpClient, private cdr: ChangeDetectorRef) {}

  onCellEditingStarted(event: CellEditingStartedEvent){
    console.log("Cell editing started!");
  }

  onCellEditingStopped(event: CellEditingStoppedEvent){
    console.log('Cell editing stopped');
    console.log(event.data);
    console.log('New value: ', event.newValue);
    this.eventData = event;
    this.editModal = true;
    this.cdr.detectChanges();
  }

  submitRateEdit(){
    console.log('weeee we are submitting a rate edit')
    let rate_uuid = '';
    let grid_type = '';
    if(this.eventData){
      if(this.eventData.data.default_zone_rate_uuid){
        rate_uuid = this.eventData.data.default_zone_rate_uuid;
        grid_type = 'default'
      }
      else if (this.eventData.data.rate_uuid){
        rate_uuid = this.eventData.data.rate_uuid
        grid_type = 'customer'
      }
      else if (this.eventData.data.carrier_zone_rate_uuid){
        rate_uuid = this.eventData.data.carrier_zone_rate_uuid;
        grid_type = 'carrier'
      }
      let putData = {
        rate_uuid: rate_uuid,
        grid_type: grid_type,
        rate: this.eventData.newValue
      }
      console.log('PutData: ', JSON.stringify(putData))
      this.http.put<any>('/api/rates/view_rates.php', putData).subscribe(
        (response) => {
          console.log(JSON.stringify(response));
        },
        (error) => {
          console.error(error)
        }
      )
      this.closeEditModal();
    }
  }

  undoRateEdit(){
    if(this.eventData){
      const rowNode = this.eventData.node;
      const columnId = this.eventData.column.getColId();
      rowNode.setDataValue(columnId, this.eventData.oldValue);
    }
    this.closeEditModal();
  }

  closeEditModal(){
    this.editModal = false;
  }

  ngOnInit(): void {
    const url = '/api/rates/view_rates.php';
    this.defaultLoading = true;  

    this.http.get(url + '?grid=default').subscribe(
      (response: any) => {
        if (response.data) {
          console.log(response.data);
          this.defaultRowData = response.data;  
        }
        this.defaultGridReady = true; 
        this.defaultLoading = false; 
        this.hideOverlay('default');  
      },
      (error: any) => {
        console.error(error);
        this.defaultLoading = false;
        this.showNoRowsOverlay('default');  
      }
    );

    this.http.get(url + '?grid=customer').subscribe(
      (response: any) => {
        if (response.data) {
          console.log(response.data);
          this.customerRowData = response.data;  
        }
        this.customerGridReady = true; 
        this.customerLoading = false; 
        this.hideOverlay('customer');  
      },
      (error: any) => {
        console.error(error);
        this.customerLoading = false;
        this.showNoRowsOverlay('customer');  
      }
    );

    this.http.get(url + '?grid=carrier').subscribe(
      (response: any) => {
        if (response.data) {
          this.carrierRowData = response.data;  
        }
        this.carrierGridReady = true; 
        this.carrierLoading = false; 
        this.hideOverlay('carrier');  
      },
      (error: any) => {
        console.error(error);
        this.carrierLoading = false;
        this.showNoRowsOverlay('carrier');  
      }
    );
  }

  ngAfterViewInit(): void {
   
    if (this.defaultGridReady) {
      this.initializeGrid('default');
    }
    if( this.customerGridReady){
      this.initializeGrid('customer');
    }
    if (this.carrierGridReady){
      this.initializeGrid('carrier');
    }
  }

  onTabChange(event: MatTabChangeEvent) {
    const gridType = event.index === 0 ? 'default' : 'customer';
    this.initializeGrid(gridType);
  }

  
  initializeGrid(gridType: string): void {
    if (gridType === 'default' && this.defaultGridApi) {
      this.defaultGridApi.sizeColumnsToFit();
      setTimeout(() => {
        this.defaultGridApi.redrawRows();  
      }, 500);
    } else if (gridType === 'customer' && this.customerGridApi) {
      this.customerGridApi.sizeColumnsToFit();
      setTimeout(() => {
        this.customerGridApi.redrawRows();
      }, 500);
    }
    else if (gridType === 'carrier' && this.carrierGridApi){
      this.carrierGridApi.sizeColumnsToFit();
      setTimeout(() => {
        this.carrierGridApi.redrawRows();
      }, 500);
    }
  }

  // onTabChange(event: MatTabChangeEvent) {
  //   this.initializeGrid(event.index)
  // }

  onGridReady(params: GridReadyEvent<any>, gridType: string) {
    if (gridType === 'default') {
      this.defaultGridApi = params.api;
  
    //uncommnet this (not this comment but what's under it) to log every single event that ag-grid does and then you can get an idea of all the possible events, then just bind them to the grid options and you can use them
      // this.defaultGridApi.addGlobalListener((eventName: string, event: any) => {
      //   console.log(`Event: ${eventName}`, event);
      // });



      // firstDataRendered to ensure the grid has finished rendering, not sure if this will work but it seems better than using a timeout
      this.defaultGridApi.addEventListener('firstDataRendered', () => {
        this.defaultGridApi.sizeColumnsToFit();
      });
  
      if (this.defaultLoading) {
        this.showLoadingOverlay('default');
      }
    } else if (gridType === 'customer') {
      this.customerGridApi = params.api;
  
      //firstDataRendered to ensure the grid has finished rendering
      this.customerGridApi.addEventListener('firstDataRendered', () => {
        this.customerGridApi.sizeColumnsToFit();
        this.customerGridApi.redrawRows();  // Safely redraw rows after rendering
      });
  
      if (this.customerLoading) {
        this.showLoadingOverlay('customer');
      }
    } else if (gridType === 'carrier') {
      this.carrierGridApi = params.api;
  
      //firstDataRendered to ensure the grid has finished rendering
      this.carrierGridApi.addEventListener('firstDataRendered', () => {
        this.carrierGridApi.sizeColumnsToFit();
        this.carrierGridApi.redrawRows();  // Safely redraw rows after rendering
      });
  
      if (this.carrierLoading) {
        this.showLoadingOverlay('customer');
      }
    }
  }
  


  // onGridReady(params: GridReadyEvent<any>, gridType: string) {
  //   if(gridType === 'default'){
  //     this.defaultGridApi = params.api;
  //     if (this.defaultLoading) {
  //       this.showLoadingOverlay();  // Show the loading overlay if data is still loading
  //       this.defaultGridApi.sizeColumnsToFit();
  //     }
  //   }
  //   else if(gridType === 'customer'){
  //     this.customerGridApi = params.api;
  //     if (this.customerLoading) {
  //       this.showLoadingOverlayCustomer();  // Show the loading overlay if data is still loading
  //       this.customerGridApi.sizeColumnsToFit();
  //     }
  //   }
  // }

  // initializeGrid(tabIndex: number): void {
  //   if(tabIndex == 0){
  //     setTimeout(() => {
  //       if (this.defaultGridApi) {
  //         this.defaultGridApi.sizeColumnsToFit();
  //       }
  //     }, 0);
  //   }
  //   else if(tabIndex == 1){
  //     console.log('initializing customer grid...')
  //     setTimeout(() => {
  //       if (this.customerGridApi) {
  //         this.customerGridApi.sizeColumnsToFit();
  //         this.customerGridApi.redrawRows();
  //       }
  //     }, 500);
  //   }
  // }


  showLoadingOverlay(gridType: string): void {
    if (gridType === 'default' && this.defaultGridApi) {
      this.defaultGridApi.showLoadingOverlay();
    } else if (gridType === 'customer' && this.customerGridApi) {
      this.customerGridApi.showLoadingOverlay();
    }
  }
  
  hideOverlay(gridType: string): void {
    if (gridType === 'default' && this.defaultGridApi) {
      this.defaultGridApi.hideOverlay();
    } else if (gridType === 'customer' && this.customerGridApi) {
      this.customerGridApi.hideOverlay();
    }
  }
  
  showNoRowsOverlay(gridType: string): void {
    if (gridType === 'default' && this.defaultGridApi) {
      this.defaultGridApi.showNoRowsOverlay();
    } else if (gridType === 'customer' && this.customerGridApi) {
      this.customerGridApi.showNoRowsOverlay();
    }
  }



  // showLoadingOverlay(): void {
  //   if (this.defaultGridApi) {
  //     this.defaultGridApi.showLoadingOverlay();
  //   }

  // }

  // showLoadingOverlayCustomer(): void {
  //   if (this.customerGridApi){
  //     this.customerGridApi.showLoadingOverlay();
  //   }
  // }

  // hideOverlay(): void {
  //   if (this.defaultGridApi) {
  //     this.defaultGridApi.hideOverlay();
  //   }
  //   if (this.customerGridApi){
  //     this.customerGridApi.hideOverlay();
  //   }
  // }

  // hideOverlayCustomer(): void {
  //   if (this.customerGridApi){
  //     this.customerGridApi.hideOverlay();
  //   }
  // }

  // showNoRowsOverlay(): void {
  //   if (this.defaultGridApi) {
  //     this.defaultGridApi.showNoRowsOverlay();
  //   }
  // }

  // showNoRowsOverlayCustomer(): void {
  //   if (this.customerGridApi){
  //     this.customerGridApi.showNoRowsOverlay();
  //   }
  // }
  

  measurementStartGetter(params: any) {
    return params.data.rate_method == 2 ? params.data.length_start : params.data.weight_start;
  }

  measurementEndGetter(params: any) {
    return params.data.rate_method == 2 ? params.data.length_end : params.data.weight_end;
  }



// @Component({
//   selector: 'app-view-rates',
//   templateUrl: './view-rates.component.html',
//   styleUrls: ['./view-rates.component.scss']
// })
// export class ViewRatesComponent {
//   gridReady: boolean = false;
//   themeClass: string = 'ag-theme-ulaap';
//   gridApi!: GridApi<any>;
//   rowData?: any[];

//   columnDefs: ColDef[] = [
//     { field: 'cost_or_billable', headerName: 'Cost or Billable?'},
//     { field: 'rate'},
//     { field: 'origin_zone_description', headerName: 'Origin Zone'},
//     { field: 'destination_zone_description', headerName: 'Destination Zone'},
//     { field: 'start_date'},
//     { field: 'end_date'},
//     { field: 'rate_method', headerName: 'Measurement Type'},
//     { field: 'rate_unit', headerName: 'Measurement Unit'},
//     { field: 'carrier_name'},
//     { field: 'customer_name'},
//     { field: 'length_start', hide: true},
//     { field: 'length_end', hide: true},
//     { field: 'weight_start', hide: true},
//     { field: 'weight_end', hide: true},
//     { field: 'measurement_start', valueGetter: this.measurementStartGetter},
//     { field: 'measurement_end', valueGetter: this.measurementEndGetter}
//   ]

//   measurementStartGetter(params: ValueGetterParams){
//     if(params.data.rate_method === 'LENGTH'){
//       return params.data.length_start
//     }
//     else{
//       return params.data.weight_start
//     }
//   }

//   measurementEndGetter(params: ValueGetterParams){
//     if(params.data.rate_method === 'LENGTH'){
//       return params.data.length_end
//     }
//     else{
//       return params.data.weight_end
//     }
//   }

//   onTabChange(event: MatTabChangeEvent) {
//     if (event.index === 0) {  // Assuming this is the index of the tab containing the grid
//       this.gridReady = true;
//       console.log('ready!')
//       setTimeout(() => {
//         this.gridApi.sizeColumnsToFit();
//       }, 0);
//     }
//   }

//   ngOnInit(): void {
//     const url = "/api/rates/view_rates.php";
//     this.http.get(url).subscribe((response: any) => {
//       if (response.data){
//         console.log(response.data);
//         this.rowData = response.data;
//       }
//     },
//     (error: any) => {
//       console.error(error)
//     }
//   )
//   }

//   onGridReady(params: GridReadyEvent<any>){
//     this.gridApi = params.api;
//     this.gridApi.sizeColumnsToFit();
//     console.log('grid ready!')
//   }

  // createDatasource(): any{
  //   return{
  //     getRows: (params: IServerSideGetRowsParams<any, any> & { sortModel: SortModelItem[], filterModel: any}) => {
  //       const sortModel = params.request.sortModel;
  //       const filterModel = params.request.filterModel;
  //       const url = this.buildUrl(params.request.startRow || 0, params.request.endRow || 0, sortModel, filterModel);
  //       this.gridApi = params.api;

  //       this.gridApi.updateGridOptions({
  //         'rowSelection': 'single',
  //         'suppressClickEdit': true
  //       })

  //       this.http.get<{ data: any[], totalRows: number}>(url).subscribe(
  //         response => {
  //           params.success( {rowData: response.data, rowCount: response.totalRows});
  //         },
  //         error => {
  //           console.error('Error fetching rates: ', error);
  //           params.fail();
  //         }
  //       )
  //     }

  //   }
  // }

  // constructor(private http: HttpClient){}

  // // Create URL to get grid data
  // buildUrl(startRow: number, endRow: number, sortModel: SortModelItem[], filterModel: any){
  //   const baseUrl = '/api/work_orders/work_orders.php'; // REPLACE THIS
  //   console.log(JSON.stringify(filterModel))
  //   const filters = encodeURIComponent(JSON.stringify(filterModel));
  //   const sort = encodeURIComponent(JSON.stringify(sortModel));
  //   let url = `${baseUrl}?startRow=${startRow}&endRow=${endRow}&filters=${filters}&sortModel=${sort}`;
  //   return url;
  // }


}
